import React from "react";
import type { LifeSelection } from "./types";

interface SelectionChipProps {
  selection: LifeSelection;
  onRemove: (itemId: string) => void;
}

export default function SelectionChip({
  selection,
  onRemove,
}: SelectionChipProps): React.ReactElement {
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium"
      style={{
        backgroundColor: "var(--c-surface-2)",
        color: "var(--c-text-secondary)",
        border: "1px solid var(--c-border)",
      }}
    >
      <span
        className="text-[9px] uppercase font-bold px-0.5 rounded"
        style={{ color: "var(--c-text-faint)" }}
      >
        {selection.primitiveType.slice(0, 3)}
      </span>
      <span className="max-w-[120px] truncate">{selection.label}</span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemove(selection.itemId);
        }}
        className="ml-0.5 transition-colors"
        style={{ color: "var(--c-text-faint)" }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = "var(--c-text-secondary)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = "var(--c-text-faint)";
        }}
      >
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M2 2l6 6M8 2l-6 6" />
        </svg>
      </button>
    </span>
  );
}
